export default "__VITE_ASSET__B2feC9Bx__"